import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { Link, useLocation, useHistory } from "react-router-dom";

import Button from "../components/buttons/button.component";
import Container from "../components/container/container.component";
import FormInput from "../components/inputs/form.input.component";
import { login } from "../data/reducers/auth";

const Login = ({ login, isAuth, isLoading, user }) => {
  const location = useLocation();   // ✅ INSIDE component
  const history = useHistory();     // ✅ INSIDE component

  const redirect = new URLSearchParams(location.search).get("redirect");

  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = data;

  const handleChange = (field) => (e) => {
    setData({ ...data, [field]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!email || !password) {
      return toast.error("Email and password are required");
    }

    login({ email, password });
  };

  // ✅ Handle redirect AFTER login success
  useEffect(() => {
    if (isAuth && user) {
      toast.success(`Welcome ${user.name}`);

      if (redirect) {
        history.push(`/${redirect}`);
      } else {
        if (user.role === "customer") {
          history.push("/dashboard");
        } else {
          history.push("/dashboard/user");
        }
      }
    }
  }, [isAuth, user, history, redirect]);

  return (
    <Container>
      <form
        onSubmit={onSubmit}
        className="bg-white rounded-lg shadow-2xl p-5 my-16 md:w-1/2 lg:w-1/3 mx-auto flex flex-col"
      >
        <h2 className="font-bold text-3xl text-center mb-5">Login</h2>

        <FormInput
          title="Email"
          placeholder="congar@example.com"
          value={email}
          handleChange={handleChange("email")}
          type="email"
        />

        <FormInput
          title="Password"
          placeholder="******"
          value={password}
          handleChange={handleChange("password")}
          type="password"
        />

        {isLoading && <div id="loading" className="self-center mb-3" />}

        {!isLoading && (
          <Button
            title="Sign In"
            type="submit"
            moreStyle="bg-blue-600 hover:bg-blue-700 text-white w-full mb-3"
          />
        )}

        <div className="flex justify-end w-full">
          <Link
            to="/register"
            className="text-gray-600 text-sm hover:underline"
          >
            Need a new account?
          </Link>
        </div>
      </form>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  isAuth: state.auth.isAuthenticated,
  isLoading: state.auth.loading,
  user: state.auth.user,
});

export default connect(mapStateToProps, { login })(Login);
